export const SWAG_IN_A_BOX = 'Swag In A Box';